module.exports = __webpack_public_path__ + "img/Weapon_144.e5e94b89.png";